import React, { useState, createContext, useContext } from 'react';
interface AvatarNavCtx {
  showProfile: boolean;
  openProfile: () => void;
  closeProfile: () => void;
}
const AvatarNavContext = createContext<AvatarNavCtx>({
  showProfile: false,
  openProfile: () => {},
  closeProfile: () => {}
});
export function AvatarNavProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [showProfile, setShowProfile] = useState(false);
  return <AvatarNavContext.Provider value={{
    showProfile,
    openProfile: () => setShowProfile(true),
    closeProfile: () => setShowProfile(false)
  }} data-id="element-61">
      {children}
    </AvatarNavContext.Provider>;
}
export function useAvatarNav() {
  return useContext(AvatarNavContext);
}